module.exports = __webpack_public_path__ + "img/62.5982753a.jpg";